import { useEffect, useState } from "react";
import { Option } from "..";
import { DisciplineService } from "../../../services";
import DropdownWithValidation from "./DropdownWithValidation";

export interface SubdisciplinePickerProps {
  id: string;
  label: string;
  onSelect: (value: string) => void;
  initialValue?: string;
  isInvalid?: boolean;
  feedback?: React.ReactNode;
}

export function SubdisciplinePicker(props: Readonly<SubdisciplinePickerProps>) {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    const fetchSubdisciplines = async () => {
      try {
        let moduleList: { value: string, text: string }[] = [{ value: "", text: "Select Subdiscipline"}];
        const data = await new DisciplineService().getSubdisciplinesAsync();
        if (!data) return;
        data.value.forEach((subdiscipline) => {
          const map = new Map(Object.entries(subdiscipline));
          const id = map.get("id");
          const name = map.get("name");
          let subdisciplineInfo = { value: id, text: name };
          moduleList.push(subdisciplineInfo);
        });
        setOptions(moduleList);
      } catch (e) {
        console.error("Error loading modules", e);
      }
    };

    fetchSubdisciplines();
  }, []);

  return (
    <DropdownWithValidation
      required={true}
      id={props.id}
      label={props.label}
      options={options}
      initialValue={props.initialValue}
      onChangeSelected={(value: React.SetStateAction<string>) => {
        props.onSelect(value.toString());
      }}
      isInvalid={props.isInvalid}
      feedback={props.feedback}
    />
  );
}

export default SubdisciplinePicker;
